import { createSlice } from "@reduxjs/toolkit";

const devicesSlice = createSlice({
  name: "devices",
  initialState: {
    currentDevices: null,
    isFetching: false,
    error: false,
    discoveredDevices: null,
    discoveredDevicesLoading: false,
    discoveredDevicesError: false,
  },
  reducers: {
    devicesStart: (state) => {
      state.isFetching = true;
    },
    devicesSuccess: (state, action) => {
      state.isFetching = false;
      state.currentDevices = action.payload;
    },
    devicesFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    deleteStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteSuccess: (state, action) => {
      state.currentDevices = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    deleteFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    discoveredDevicesStart: (state) => {
      state.discoveredDevicesLoading = true;
      state.discoveredDevicesError = false;
    },
    discoveredDevicesSuccess: (state, action) => {
      state.discoveredDevicesLoading = false;
      state.discoveredDevices = action.payload;
    },
    discoveredDevicesFailure: (state) => {
      state.discoveredDevicesLoading = false;
      state.discoveredDevicesError = true;
    },
    logoutInfoDevices: (state) => {
      state.currentDevices = null;
      state.isFetching = false;
      state.error = false;
      state.discoveredDevices = null;
      state.discoveredDevicesLoading = false;
      state.discoveredDevicesError = false;
    },
  },
});

export const {
  devicesStart,
  devicesSuccess,
  devicesFailure,
  deleteStart,
  deleteSuccess,
  deleteFailure,
  discoveredDevicesStart,
  discoveredDevicesSuccess,
  discoveredDevicesFailure,
  logoutInfoDevices
} = devicesSlice.actions;
export default devicesSlice.reducer;
